import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/src/styles/main.sass";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: '#3f51b5',
        secondary: '#B0BEC5', //'#92b4cc',
        accent: '#009688',
        error: '#f44336',
        warning: '#ff9800',
        info: '#03a9f4',
        success: '#4caf50',
        //background: '#f8f8f8'
      },
      dark: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        //background: '#464646'
      },

    },
  },
});
